<template>
  <div class="questionnaire__question">
    <fieldset v-if="$slots.question" class="form-fieldset">
      <legend
        class="form-fieldset__legend form-fieldset__legend--questionnaire"
      >
        <slot name="question" />
      </legend>
      <slot name="fields" />
    </fieldset>
    <div v-else class="form-fieldset">
      <div
        class="form-fieldset__legend form-fieldset__legend--questionnaire"
      ></div>
      <slot name="fields" />
    </div>
  </div>
</template>

<script>
export default {
  inject: ['questionnaireContext', 'questionnaireItemContext'],
  data: function () {
    return {
      index: 0,
    };
  },
  mounted() {
    this.questionnaireContext.registerQuestion();
    this.index = this.getIndex();
    this.questionnaireItemContext.registerQuestion(this.index);
  },
  methods: {
    getIndex() {
      const questions = document.querySelectorAll(
        `#questionnaire-${this.questionnaireContext.uuid} .questionnaire__question`
      );
      return Array.from(questions).findIndex(element => this.$el === element);
    },
  },
};
</script>
